// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

class MessagingProvider extends React.Component {
    componentDidMount() {
        // this.props.registerServiceWorker();
        // this.props.initializeCloudMessaging();
        
        // logging our messaging notification
        // messaging.onMessage(payload => {
        //     console.log(payload);
        // })
    }

    render(){
        return (
                <React.Fragment>
                </React.Fragment>
        );
    }
};

export default connect(null, actions)(MessagingProvider);



// WEBPACK FOOTER //
// ./src/MessagingProvider.jsx